export default __webpack_public_path__ + "static/media/Il Vincitore Marino Magliani.e6a5891d.jpg";